import React from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Container,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormText
} from "reactstrap";
import NotificationSystem from "react-notification-system";

import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";

import AirlineTable from "./airline-table";

//Icons
import AddIcon from "react-icons/lib/md/library-add";
import AirlineIcon from "react-icons/lib/md/airplanemode-active";
import { appHelpers, store } from "../../_helpers";
import { commonService } from "../../_services";
import { operationsService } from "../../_services/operations.service";
const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class AirlineViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlines: [],
      formattedAirlines: [],
      modal: false,
      modalClass: "",
      //airline form
      airlineId: false,
      airlineName: "",
      shortName: "",
      aviationCode: "",
      airlineCode: "",
      ticketFormat: "",
      sisId: "",
      IsLocal: false,
      carrier: false,
      expMinPax: 0,
      expMaxPax: 1,
      expMinFlights: 0,
      expMaxFlights: 1,

      //page error
      contentError: false, //Errors that affect content on the page
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      CreateAirlineEntityTypeId: null,
      EditAirlineEntityTypeId: null
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { airlines, entities } = reduxState;
    const { dispatch } = this.props;

    if (airlines) {
      this.setState({ airlines: airlines.Results });
    } else {
      this.fetchAirlines();
    }
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { modal, alert, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.airlineName === "") {
      _errs_["airlineName"] = "Please enter airline name";
      formValid = false;
    }
    if (this.state.shortName === "") {
      _errs_["shortName"] = "Please enter short name";
      formValid = false;
    }
    if (this.state.airlineCode === "") {
      _errs_["airlineCode"] = "Please enter airline name";
      formValid = false;
    }
    if (this.state.aviationCode === "") {
      _errs_["aviationCode"] = "Please enter aviation name";
      formValid = false;
    }
    if (this.state.airlineCode === "") {
      _errs_["airlineCode"] = "Please enter airline code";
      formValid = false;
    }
    if (this.state.ticketFormat === "") {
      _errs_["ticketFormat"] = "Please enter ticket format";
      formValid = false;
    }
    if (this.state.sisId === "") {
      _errs_["sisId"] = "Please enter SSID";
      formValid = false;
    }
    if (this.state.expMinPax === "") {
      _errs_["expMinPax"] = "Please enter expected minimum passengers";
      formValid = false;
    }
    if (this.state.expMinPax < 0) {
      _errs_["expMinPax"] = "Please enter a value greater than 0";
      formValid = false;
    }
    if (this.state.expMaxPax === "") {
      _errs_["expMaxPax"] = "Please enter expected maximum passengers";
      formValid = false;
    }
    if (this.state.expMaxPax < 0) {
      _errs_["expMexpMaxPaxinPax"] = "Please enter a value greater than 0";
      formValid = false;
    }
    if (this.state.expMinFlights === "") {
      _errs_["expMinFlights"] = "Please enter expected minimum flights";
      formValid = false;
    }
    if (this.state.expMinFlights < 0) {
      _errs_["expMinFlights"] = "Please enter a value greater than 0";
      formValid = false;
    }
    if (this.state.expMaxFlights === "") {
      _errs_["expMaxFlights"] = "Please enter expected maximum flights";
      formValid = false;
    }
    if (this.state.expMaxFlights < 0) {
      _errs_["expMaxFlights"] = "Please enter a value greater than 0";
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  setEntityTypes = entities => {
    let CreateAirlineEntityTypeId;
    let EditAirlineEntityTypeId;

    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_AIRLINE) {
        CreateAirlineEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.UPDATE_AIRLINE
      ) {
        EditAirlineEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ CreateAirlineEntityTypeId, EditAirlineEntityTypeId });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      airlineId: false,
      airlineName: "",
      shortName: "",
      aviationCode: "",
      airlineCode: "",
      ticketFormat: "",
      sisId: "",
      IsLocal: false,
      carrier: false,
      expMinPax: "",
      expMaxPax: "",
      expMinFlights: "",
      expMaxFlights: ""
    });
    this.resetError();
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    let { airlineId } = this.state;
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      Name: this.state.airlineName,
      ShortName: this.state.shortName,
      AviationCode: this.state.aviationCode,
      Code: this.state.airlineCode,
      TicketFormat: this.state.ticketFormat,
      AirlineSisId: this.state.sisId,
      IsLocal: this.state.IsLocal,
      Carrier: this.state.carrier,
      ExpectedMinPax: this.state.expMinPax,
      ExpectedMaxPax: this.state.expMaxPax,
      ExpectedMinFlights: this.state.expMinFlights,
      ExpectedMaxFlights: this.state.expMaxFlights
    };
    if (airlineId) {
      payload.Id = airlineId;
    }

    if (userRole === appConstants.ROLES.SUPER_ADMIN) {
      this.createAirline(payload);
    } else {
      this.createMakerChecker(payload);
    }
  };

  createAirline = payload => {
    const { dispatch } = this.props;

    commonService.manageAirline(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airline updated successfully"
          : "Airline created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
        this.fetchAirlines();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = payload => {
    const { dispatch } = this.props;
    const {
      airlineId,
      CreateAirlineEntityTypeId,
      EditAirlineEntityTypeId
    } = this.state;
    const { authentication } = store.getState();

    /* Maker checker */
    let payloadTemplate = {
      Name: this.state.airlineName,
      ShortName: this.state.shortName,
      AviationCode: this.state.aviationCode,
      Code: this.state.airlineCode,
      TicketFormat: this.state.ticketFormat,
      AirlineSisId: this.state.sisId,
      // ExpectedMinPax: this.state.expMinPax, ExpectedMaxPax: this.state.expMaxPax,
      // ExpectedMinFlights: this.state.expMinFlights, ExpectedMaxFlights: this.state.expMaxFlights,
      IsLocal: this.state.IsLocal ? "Yes" : "No",
      Carrier: this.state.carrier ? "Yes" : "No"
    };

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/airline/save`,
      EntityTypeId: CreateAirlineEntityTypeId,
      CreatedBy: authentication.user.userName
    };

    if (airlineId) {
      makerCheckerPayload.EntityTypeId = EditAirlineEntityTypeId;
    }

    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airline update sent successfully"
          : "Airline creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  handleAirlinesDownload = () => {
    const { dispatch } = this.props;
    const { 
      airlineValue, 
      selectValue,
      pageSize,
      startDate,
      endDate,
    } = this.state;

    // let payload = {
    //   PageSize: pageSize,
    //   From: fromPage,
    //   Parameter: {
    //     AirlineId: airlineValue && airlineValue.Id ? airlineValue.Id : "",
    //     IsLocal: airlineValue && airlineValue.IsLocal ? airlineValue.IsLocal : "",
    //     StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
    //     EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59"
    //   },
    // };
  
    dispatch(apiActions.startRequest());
  
    operationsService
      .airlineOperationsDownload()
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          // const fileUrl = res.response.data.File;
          // window.open(fileUrl, "_blank");
          let response = res.response.data;
  
          const isBase64 = response.base64File ? true : false;
          const fileData = response.base64File || response; // filestream is in response directly
          // const mimeType = response.type || "application/pdf";
          // normalize mime type
          let mimeType = response.type || "application/pdf";
          if (mimeType === "application/xls") {
            mimeType = "application/vnd.ms-excel"; // correct for old .xls
          }
          appHelpers.downloadFileV2(
            fileData,
            "Airlines_Report",
            isBase64,
            mimeType
          );
        }
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        dispatch(alertActions.error("Download failed"));
        dispatch(apiActions.endRequest());
      });
  };
  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlines } = this.props;
    if (!airlines) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAllAirlines())
      .then(() => {
        let { airlines } = this.props;
        this.setState({ airlines: airlines.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  passAirlineDetails = airline => {
    this.setState({
      airlineId: airline.Id,
      airlineName: airline.Name ? airline.Name : "",
      airlineCode: airline.Code ? airline.Code : "",
      shortName: airline.ShortName ? airline.ShortName : "",
      aviationCode: airline.AviationCode ? airline.AviationCode : "",
      ticketFormat: airline.TicketFormat ? airline.TicketFormat : "",
      sisId: airline.AirlineSisId ? airline.AirlineSisId : "",
      expMinPax: airline.ExpectedMinPax ? airline.ExpectedMinPax : "",
      expMaxPax: airline.ExpectedMaxPax ? airline.ExpectedMaxPax : "",
      expMinFlights: airline.ExpectedMinFlights
        ? airline.ExpectedMinFlights
        : "",
      expMaxFlights: airline.ExpectedMaxFlights
        ? airline.ExpectedMaxFlights
        : "",
      IsLocal: airline.IsLocal,
      carrier: airline.Carrier
    });
    this.toggle(null, "modalSlideIn");
  };
  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleCheckbox = attribute => {
    let currState = this.state;
    currState[attribute] = !currState[attribute];
    this.setState(currState);
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting } = this.props;
    const { pageRequesting } = this.props;
    const { contentError, airlines, componentErrorMessages } = this.state;
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    Airlines
                    <FormText color="muted">
                      <AirlineIcon size="18" color="#43a8df" />
                      {airlines.length} records
                    </FormText>
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      disabled={pageRequesting || requesting}
                      onClick={e => this.toggle(e, "modalSlideIn")}
                    >
                      <AddIcon color="#ffffff" size="20" />
                      &nbsp;Create Airline
                    </Button>{" "}
                  </div>
                </div>

                {!pageRequesting && (
                  <AirlineTable
                    data={airlines}
                    editCallback={this.passAirlineDetails}
                    handleAirlinesDownload={this.handleAirlinesDownload}
                  />
                )}
                <Modal
                  size={"md"}
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.state.modalClass}
                >
                  <ModalHeader toggle={this.toggle}>Create Airline</ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}
                      <Container>
                        <Row>
                          <Col sm="12">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.airlineName
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airline Name</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.airlineName}
                                onChange={event =>
                                  this.handleChange(event, "airlineName")
                                }
                              />
                              {componentErrorMessages.airlineName && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.airlineName}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.shortName
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airline Short Name</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.shortName}
                                onChange={event =>
                                  this.handleChange(event, "shortName")
                                }
                              />
                              {componentErrorMessages.shortName && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.shortName}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.airlineCode
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airline Code</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.airlineCode}
                                onChange={event =>
                                  this.handleChange(event, "airlineCode")
                                }
                              />
                              {componentErrorMessages.airlineCode && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.airlineCode}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.aviationCode
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Aviation Code</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.aviationCode}
                                onChange={event =>
                                  this.handleChange(event, "aviationCode")
                                }
                              />
                              {componentErrorMessages.aviationCode && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.aviationCode}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.ticketFormat
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Ticket Format</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.ticketFormat}
                                onChange={event =>
                                  this.handleChange(event, "ticketFormat")
                                }
                              />
                              {componentErrorMessages.ticketFormat && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.ticketFormat}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.sisId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>SSID</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.sisId}
                                onChange={event =>
                                  this.handleChange(event, "sisId")
                                }
                              />
                              {componentErrorMessages.sisId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.sisId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* <Row>
                                                    <Col sm="6">
                                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.expMinPax ? 'has-danger' : '')}>
                                                            <Label>Expected Minimum Passengers</Label>
                                                            <Input type="number" placeholder="" value={this.state.expMinPax} onChange={(event) => this.handleChange(event, 'expMinPax')} />
                                                            {componentErrorMessages.expMinPax && <FormText color="danger"> {componentErrorMessages.expMinPax}</FormText>}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.expMaxPax ? 'has-danger' : '')}>
                                                            <Label>Expected Maximum Passengers</Label>
                                                            <Input type="number" placeholder="" value={this.state.expMaxPax} onChange={(event) => this.handleChange(event, 'expMaxPax')} />
                                                            {componentErrorMessages.expMaxPax && <FormText color="danger"> {componentErrorMessages.expMaxPax}</FormText>}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="6">
                                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.expMinFlights ? 'has-danger' : '')}>
                                                            <Label>Expected Minimum Flights</Label>
                                                            <Input type="number" placeholder="" value={this.state.expMinFlights} onChange={(event) => this.handleChange(event, 'expMinFlights')} />
                                                            {componentErrorMessages.expMinFlights && <FormText color="danger"> {componentErrorMessages.expMinFlights}</FormText>}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.expMaxFlights ? 'has-danger' : '')}>
                                                            <Label>Expected Maximum Flights</Label>
                                                            <Input type="number" placeholder="" value={this.state.expMaxFlights} onChange={(event) => this.handleChange(event, 'expMaxFlights')} />
                                                            {componentErrorMessages.expMaxFlights && <FormText color="danger"> {componentErrorMessages.expMaxFlights}</FormText>}
                                                        </FormGroup>
                                                    </Col>
                                                </Row> */}
                        <Row>
                          <Col sm="12">
                            <FormGroup>
                              <input
                                type="checkbox"
                                className="checkbox-control"
                                name="disabled"
                                checked={this.state.IsLocal}
                                onChange={() => this.toggleCheckbox("IsLocal")}
                              />
                              <span className="checkbox-label">
                                &nbsp;Is local?
                              </span>
                              &nbsp;&nbsp;
                              <input
                                type="checkbox"
                                className="checkbox-control"
                                name="disabled"
                                checked={this.state.carrier}
                                onChange={() => this.toggleCheckbox("carrier")}
                              />
                              <span className="checkbox-label">
                                &nbsp;Carrier
                              </span>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>

                  {requesting && <div className={"loading-dot active"} />}
                </Modal>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, airlines, entities } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    airlines,
    entities
  };
}
export default connect(mapStateToProps)(AirlineViewContent);



// WEBPACK FOOTER //
// ./src/views/airline/view-content.js